// extracted by mini-css-extract-plugin
export var dropdown = "_hr-0";
export var imagePlaceholder = "_hr-2";
export var imageWrapper = "_hr-3";
export var productImage = "_hr-1";
export var truncateContainer = "_hr-4";
export var truncateText = "_hr-5";